export default [
    {
        id: 'B',
        label: 'Burst',
    },
    {
        id: 'P',
        label: 'Piercing',
    },
    {
        id: 'G',
        label: 'Guided',
    },
    {
        id: 'M',
        label: 'Multi',
    },
];
